import styles from '../Legal.module.css';

const sections = [
  { title: '1. Acceptance of terms', text: 'By using this site or the Solvora template, you agree to these terms of use. If you do not agree, please discontinue use.' },
  { title: '2. License', text: 'Solvora is licensed for use in personal and commercial projects. Redistribution or resale of the template itself, unmodified, is not permitted.' },
  { title: '3. Acceptable use', text: 'You agree not to use this site to transmit unlawful, harmful, or infringing content, or to attempt to disrupt the service for other users.' },
  { title: '4. Intellectual property', text: 'All design, code structure, and original content on this site remain the property of Solvora unless otherwise licensed to you.' },
  { title: '5. Disclaimer', text: 'This site and template are provided "as is" without warranties of any kind, express or implied, including fitness for a particular purpose.' },
  { title: '6. Limitation of liability', text: 'Solvora is not liable for any indirect, incidental, or consequential damages arising from use of this site or template.' },
  { title: '7. Changes to these terms', text: 'We may revise these terms from time to time. Continued use of the site after changes constitutes acceptance of the revised terms.' },
];

export default function Terms() {
  return (
    <section className={styles.section}>
      <div className={`container ${styles.wrap}`}>
        <span className={styles.eyebrow}>Legal</span>
        <h1 className={styles.title}>Terms of Use</h1>
        <p className={styles.updated}>Effective date: January 1, 2026</p>
        <p className={styles.intro}>
          These terms govern your use of this site and the Solvora template. Please read
          them carefully before using either.
        </p>
        {sections.map((s) => (
          <div key={s.title} className={styles.block}>
            <h2 className={styles.h2}>{s.title}</h2>
            <p className={styles.p}>{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
